import styles from './Chip.module.css'

interface ChipProps {
  label: string
  selected?: boolean
  icon?: React.ReactNode
  disabled?: boolean
  onClick?: () => void
}

export default function Chip({ label, selected, icon, disabled, onClick }: ChipProps) {
  const Tag = onClick ? 'button' : 'span'
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      className={[styles.chip, selected && styles.selected].filter(Boolean).join(' ')}
      onClick={onClick}
      disabled={onClick ? disabled : undefined}
      aria-pressed={onClick ? !!selected : undefined}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      {label}
    </Tag>
  )
}
